import type { NPCConfig } from '@/entities';
import v2Day1SharedNPCs from "@/config/NPCConfigs/v2/V2Day1SharedNPCs.ts";
// import {StoryManager} from "@/systems";

const config: NPCConfig[] = [
  //Bunga : lagi didepan rumah kalau didkeetin trigger auto next 'stage;, dia bilang ulang tahn
  //
  ...v2Day1SharedNPCs,
  {
    x: 3950,
    y: 860,
    name: 'Kuburan Ibu',
    spriteImage: 'assets/sprite/nada.png', // Use NPC image
    dialogTree: {
      startDialogId: 'kuburan1',
      nodes: {
        kuburan1: {
          id: 'penjual_part1_1',
          speaker: 'Yan',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/grave_empty.ktx2',
          text: `Ini adalah tempat ibu dikubur...`,
          nextDialogId : "kuburan2",
        },
        kuburan2: {
          id: 'kuburan2',
          speaker: 'Yan',
          text: `Kadang merasa sedih jika mengingat masa kecil, saat aku dan Diana ditinggal oleh Ibu`,
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/grave_empty.ktx2',
          nextDialogId : "kuburan3",
        },
        kuburan3: {
          id: 'kuburan3',
          speaker: 'Yan',
          text: `Orang desa pun masih tidak tahu bagaimana ibu bisa meninggal, ataupun dia benar-benar meninggal. Sedangkan aku dan Diana masih sangat kecil.`,
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/grave_empty.ktx2',
          nextDialogId : "kuburan3a",
        },
        kuburan3a: {
          id: 'kuburan3',
          speaker: 'Yan',
          text: `Nenek membuat kuburan ini sebagai peringatan untuk ibu.`,
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/grave_empty.ktx2',
          nextDialogId : "kuburan4",
        },
        kuburan4: {
          id: 'kuburan4',
          speaker: 'Yan',
          text: `Sejak saat itu kita dibesarkan oleh nenek, kami sangat berterima kasih ke nenek. Semoga nenek sehat selalu`,
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/grave_empty.ktx2',
          nextDialogId : "kuburan5",
        },
        kuburan5: {
          id: 'kuburan4',
          speaker: 'Yan',
          text: `Oh apa ini di kuburan, sepertinya ada uang`,
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/grave_empty.ktx2',
          nextDialogId : "kuburan6",
        },
        kuburan6: {
          id: 'kuburan5',
          speaker: 'Yan',
          text: ``,
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/grave_empty.ktx2',
          choices: [
            {
              text: '[Curi] Ambil uang itu.',
              itemReward: { itemId: 'coin_gold', quantity: 200},
              nextDialogId : "kuburan6a",
            },
            {
              text: '[Jujur] Jangan Ambil',
              nextDialogId : "kuburan6b",
            },
          ],
        },
        kuburan6a: {
          id: 'kuburan4',
          speaker: 'Yan',
          text: `Yan mendapat 200 rupiah!`,
          storyActions : [
            { type: 'addCustomValue', value: {key : "general_karma", value : -1} },
            { type: 'addState', value: "MONEY_TAKEN" },
          ],
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/grave_empty.ktx2',
          isEnd : true,
        },
        kuburan6b: {
          id: 'kuburan4',
          speaker: 'Yan',
          text: `Sebaiknya kita tinggalkan uang ini.`,
          storyActions : [
            { type: 'addCustomValue', value: {key : "general_karma", value : 1} },
            { type: 'addState', value: "MONEY_NOT_TAKEN" },
          ],
          backgroundImage: '/assets/backdrop/grave_empty.ktx2',
          characterImage: '/assets/character/v2/yanf.png',
          isEnd : true,
        },
      },
    },
  },
  {
    x: 3450,
    y: 1350,
    name: 'Bunga',
    interactionRadius : 30,
    spriteImage: 'assets/sprite/sprite_bunga.png', // Use NPC image
    dialogTree: {
      startDialogId: 'bunga1',
      triggerOnCollision: true,
      nodes: {
        bunga1: {
          id: 'bunga1',
          speaker: 'Bunga',
          characterImage: '/assets/character/v2/bunga_h.png',
          text: `Halo Yan, apakah sudah bertemu dengan Diana?`,
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          nextDialogId : "bunga2",
        },
        bunga2: {
          id: 'bunga2',
          speaker: 'Bunga',
          characterImage: '/assets/character/v2/bunga_h.png',
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          text: ``,
          choices: [
            {
              text: 'Diana sedang mencari Elsa di danau.',
              nextDialogId : "bunga3",
            },
            {
              text: 'Diana sedang ke danau.',
              nextDialogId : "bunga4",
            },
          ],
        },
        bunga3: {
          id: 'bunga3',
          speaker: 'Bunga',
          characterImage: '/assets/character/v2/bunga_a.png',
          text: `Elsa... Merepotkan semua orang saja.`,
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          nextDialogId : "bunga4",
        },
        bunga4: {
          id: 'bunga4',
          speaker: 'Bunga',
          characterImage: '/assets/character/v2/bunga.png',
          text: `Baiklah, kalau begitu aku juga akan ke Danau.`,
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          nextDialogId : "bunga5",
        },
        bunga5: {
          id: 'bunga4',
          speaker: 'Bunga',
          characterImage: '/assets/character/v2/bunga.png',
          text: `Sebaiknya kamu menyusul setelah menemukan kado untuk Diana.`,
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          nextDialogId : "bunga6"
        },
        bunga6: {
          id: 'bunga6',
          speaker: 'Bunga',
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          text: ``,
          choices: [
            {
              text: '[Bohong] Tenang saja. Kado sudah siap, tinggal dibungkus dan aku menyusul!',
              nextDialogId : 'bunga7',
              storyActions :  [
                { type: 'addCustomValue', value: {key : "general_karma", value : -1} },
              ]
            },
            {
              text: '[Jujur] Berikan aku waktu, masih aku cari. Nanti aku segera datang',
              nextDialogId : 'bunga7',
            },
          ],
        },

        bunga7: {
          id: 'bunga4',
          speaker: 'Bunga',
          characterImage: '/assets/character/v2/bunga.png',
          text: `Ok, sampe jumpa Yan`,
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          nextDialogId : "part3_opening0",
        },
        part3_opening0: {
          id: 'part3_opening0',
          speaker: 'Yan',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          text: `Sebaiknya aku ke danau setelah menemukan sesuatu untuk diberikan untuk Diana.`,
          storyActions: [
            { type: 'addState', value: "BUNGA_NOT_ON_SONDAKH_DEATH" },
            { type: 'nextDay', value: 1 },
          ],
          isEnd : true
        },
      },
    },
  },
  // {
  //   x: 3900,
  //   y: 2100,
  //   name: '',
  //   color: 0x9932cc, // Dark orchid
  //   spriteImage: 'assets/sprite/sprite_sondakh_dead.png', // Use NPC image
  //   repeatable: true, // Day Keeper should have repeatable dialogs
  //   dialogTree: {
  //     startDialogId: 'bunga_part2_1',
  //     nodes: {
  //       bunga_part2_1: {
  //         id: 'bunga_part2_1',
  //         speaker: '',
  //         text: ``,
  //         characterImage: '/assets/character/v2/bunga.png',
  //         backgroundImage: '/assets/cutscene/death_sondakh.ktx2',
  //         nextDialogId : "bunga_day1_2",
  //         isEnd : true
  //       },
  //     },
  //   },
  // },
];

export default config;
